import { Languages } from "src/common/descriptions/types";
import { ServiceCategoriesDescriptions } from "./types";

const DescriptionsEnUs: ServiceCategoriesDescriptions = {
    TITLE: "Service Categories",
    TABLE: {
        ACTION_BUTTON: "Create Service Category",
        SEARCH_PLACEHOLDER: "Search Service Category",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        NAME: "Name",
        STATUS: "Status",
        ACTIONS: "Actions",
    },
}

const DescriptionsEsUs: ServiceCategoriesDescriptions = {
    TITLE: "Categorías de Servicios",
    TABLE: {
        ACTION_BUTTON: "Crear Categoría",
        SEARCH_PLACEHOLDER: "Buscar Categoría",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        NAME: "Nombre",
        STATUS: "Estado",
        ACTIONS: "Acciones",
    },
}

export const serviceCategoriesDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}